import React from 'react';
import { connect } from 'react-redux';
import { setRebarDesign, setEurocodePlusFireMinute } from '@reducers/selectors/design/actions';
import { standardList, brandList } from '../../../../app.values';
import { REBAR } from "../../../../reducers/selectors/design/types";
import { APP_TEXTS } from '../../../../texts/texts';
import { APP_TYPES, BRAND } from '@config';

class Method extends React.Component {

  // state = {
  //   design: this.props.design
  // };

  render() {
    return (
      <div className="calculation method-tab">
        {this.props.designStandard === standardList['AS3600'] || this.props.designStandard === standardList['ANZ'] ? (
          <section className="list-type">
            <label htmlFor={REBAR.types.AS3600}>
              <input
                id={REBAR.types.AS3600}
                type="radio"
                name="options"
                onChange={(e) => this.props.setRebarDesign(e.target.id)}
                checked={this.props.design === REBAR.types.AS3600}
              />
              <b>
                &nbsp;
                <span className="text-uppercase">{APP_TEXTS.DESIGN_REBAR_LABEL_AS3600.Content}</span>
              </b>
            </label>
            <span>{APP_TEXTS.DESIGN_REBAR_AS3600_DESCRIPTION.Content}</span>
          </section>
        ) : (this.props.designStandard === standardList['AS5216'] ? (
          <section className="list-type">
            <label htmlFor={REBAR.types.AS5216}>
              <input
                id={REBAR.types.AS5216}
                type="radio"
                name="options"
                onChange={(e) => this.props.setRebarDesign(e.target.id)}
                checked={this.props.design === REBAR.types.AS5216}
              />
              <b>
                &nbsp;
                <span className="text-uppercase">{APP_TEXTS.DESIGN_REBAR_LABEL_AS5216.Content}</span>
              </b>
            </label>
            <span></span>
          </section>
        ) : (
          <div>
            <section className="list-type">
              <label htmlFor={REBAR.types.EUROCODE_2}>
                <input
                  id={REBAR.types.EUROCODE_2}
                  type="radio"
                  name="options"
                  onChange={(e) => this.props.setRebarDesign(e.target.id)}
                  checked={this.props.design === REBAR.types.EUROCODE_2}
                />
                <b>
                  &nbsp;
                  <span className="text-uppercase">
                    {APP_TEXTS.DESIGN_REBAR_EUROCODE2.Content}
                  </span>
                  {APP_TEXTS.DESIGN_REBAR_APPLICATION.Content}
                </b>
              </label>
              <span>{APP_TEXTS.REBAR_ANCHORING_LENGTH.Content}</span>
            </section>

            <section className="list-type">
              <label htmlFor={REBAR.types.EUROCODE_2_FIRE}>
                <input
                  id={REBAR.types.EUROCODE_2_FIRE}
                  type="radio"
                  name="options"
                  onChange={(e) => this.props.setRebarDesign(e.target.id)}
                  checked={this.props.design === REBAR.types.EUROCODE_2_FIRE}
                  disabled={this.props.rebarType === '2'} // disable for beam to wall 
                />
                <b>
                  &nbsp;
                  <span className="text-uppercase">{APP_TEXTS.DESIGN_REBAR_EUROCODE2.Content}</span>
                  {APP_TEXTS.DESIGN_REBAR_APPLICATION.Content} + &nbsp;
                  <span className="text-uppercase">{APP_TEXTS.DESIGN_REBAR_FIRE.Content}</span>
                  {APP_TEXTS.DESIGN_REBAR_CALCULATION.Content}
                </b>
              </label>
              <span>{APP_TEXTS.DESIGN_RESISTANCE_EC2.Content}.</span>

              <label htmlFor={APP_TEXTS.DESIGN_REBAR_MINUTE.Content}>
                <select
                  id="minute"
                  name="minute"
                  disabled={this.props.design !== REBAR.types.EUROCODE_2_FIRE}
                  className="form-control w-25 mr-2"
                  defaultValue={this.props.eurocodePlusFireMinute}
                  onChange={e => this.props.setEurocodePlusFireMinute(e.target.value)}
                >
                  <option value="30">30</option>
                  <option value="60">60</option>
                  <option value="90">90</option>
                  <option value="120">120</option>
                  <option value="180">180</option>
                  <option value="240">240</option>
                </select>
              {APP_TEXTS.DESIGN_REBAR_MINUTE.Content}
              </label>
            </section>

            <section className="list-type">
              <label htmlFor={REBAR.types.EUROCODE_2_SEISMIC}>
                <input
                  id={REBAR.types.EUROCODE_2_SEISMIC}
                  type="radio"
                  name="options"
                  onChange={(e) => this.props.setRebarDesign(e.target.id)}
                  checked={this.props.design === REBAR.types.EUROCODE_2_SEISMIC}
                />
                <b>
                  &nbsp;
                  <span className="text-uppercase">{APP_TEXTS.DESIGN_REBAR_LABEL_EUROCODE2.Content}</span>
                  {APP_TEXTS.METHOD_SEISMIC_CALCULATION.Content}
                </b>
              </label>
              <span>{APP_TEXTS.CALCULATION_SEISMIC_ZONE_DTA.Content}</span>
            </section>
          </div>
        ))}

        {(this.props.designStandard === standardList['EU'] || this.props.designStandard === standardList['AnnexC']) && 
          BRAND !== brandList.Ramset && (
          <section className="list-type">
            <label htmlFor={REBAR.types.VARIO_ADHESIVE_METHOD}>
              <input
                id={REBAR.types.VARIO_ADHESIVE_METHOD}
                type="radio"
                name="options"
                onChange={(e) => this.props.setRebarDesign(e.target.id)}
                defaultChecked={this.props.design === REBAR.types.VARIO_ADHESIVE_METHOD}
              />
              <b>
                &nbsp;
                <span className="text-uppercase">{APP_TEXTS.DESIGN_REBAR_LABEL_VARIO.Content}</span>
                {APP_TEXTS.DESIGN_REBAR_ADHESIVE_METHOD.Content}
              </b>
            </label>
          </section>
        )}

      </div>
    );
  }

  setDesign = (design) => {
    // this.setState({
    //   design
    // });

    this.props.setRebarDesign(design);
  };

}

const mapState = state => ({
  designStandard: Number(state.main.localization.designStandard),
  design: state.selectors.design[state.main.appType].design,
  eurocodePlusFireMinute: state.selectors.design[state.main.appType].eurocodePlusFireMinute,
  rebarType: state.selectors.application[APP_TYPES.REBAR_REINFORCEMENT].activeBtn,
  appStatus: state.main.status // use it as a hack to render a potential language change
});

const mapDispatch = {
  setRebarDesign,
  setEurocodePlusFireMinute
};

export default connect(mapState, mapDispatch)(Method);



// WEBPACK FOOTER //
// ./src/views/Design/components/Rebar/index.js